import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor() {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				let errorMessage = '';

				if (error.status === 401) {
					errorMessage = 'Unauthorized';
					// Unauthorized error handling (logout user, redirect to login page)
					// this.authService.logOut();
				} else if (error.status === 403) {
					errorMessage = 'Forbidden';
				} else if (error.status === 404) {
					errorMessage = 'Not Found';
				} else if (error.status === 500) {
					errorMessage = 'Internal Server Error';
				} else if (error.status === 0) {
					errorMessage = 'Server is not reachable';
				} else if (error.status === 422) {
					errorMessage = error?.error?.message || 'Validation Error';
				} else {
					errorMessage = `Message: ${error.message}`;
				}

				if (errorMessage) {
					// Display error message (you can use a toast/alert service here)
					console.error('HTTP Error:', errorMessage);
					// Uncomment and use your sweet alert service when available:
					// this.sweetAlertService.errorMessage(errorMessage);
				}

				return throwError(() => error);
			})
		);
	}
}
